import { ChangeEvent, useState } from 'react';
import { Alert, Button, ControlLabel, Form, FormControl, FormGroup, Panel } from 'react-bootstrap';
import { IStrongBoxComplianceItem } from '@nkr/models/center-performance';
import useStrongBoxPhysicalInventory from '@nkr/store/strong-box/hooks/use-strong-box-physical-inventory';
import useStrongBoxOpoPhysicalInventory from '@nkr/store/strong-box-opo/hooks/use-strong-box-opo-physical-inventory';

interface IProps {
    item: IStrongBoxComplianceItem,
    isCenter: boolean,
    onItemResolved: (item: IStrongBoxComplianceItem) => void
}

const PhysicalCompliancePanel = ({ item, isCenter, onItemResolved }: IProps) => {
    const [quantity, setQuantity] = useState<string>('');
    const [initials, setInitials] = useState<string>('');

    const handleQtyChange = (e: ChangeEvent<HTMLInputElement>) => {
        const input = e.currentTarget.value;

        // Allow empty input
        if (input === '') {
            setQuantity('');
            return;
        }

        // Allow '0' or numbers without leading zeros
        if (input === '0' || /^[1-9][0-9]*$/.test(input)) {
            setQuantity(input);
        }
    };

    const handleInitialChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.currentTarget.value;
        const alphaPattern = /^[a-zA-Z]*$/;

        if (alphaPattern.test(newValue)) {
            const upperCaseValue = newValue.slice(0, 3).toUpperCase();
            setInitials(upperCaseValue);
        }
    };

    const valid = quantity && initials;
    const btnTitle = valid ? '' : 'Quantity and Initials are required fields.';

    const centerInventory = useStrongBoxPhysicalInventory(() => {
        onItemResolved(item);
    });

    const opoInventory = useStrongBoxOpoPhysicalInventory(undefined, () => {
        onItemResolved(item);
    });

    const handleSave = () => {
        if (isCenter) {
            centerInventory.record(item.centerId, parseInt(quantity), initials);
        } else {
            opoInventory.record(item.opoId, parseInt(quantity), initials);
        }
    };

    const loading = isCenter ? centerInventory.loading : opoInventory.loading;
    const error = isCenter ? centerInventory.error : opoInventory.error;

    return (
        <Panel>
            <Panel.Heading>Physical Inventory Compliance</Panel.Heading>
            <Panel.Body>
                <p>{isCenter ? 'Please confirm how many StrongBoxes your center currently has on hand...' : 'Please confirm how many StrongBoxes you have on hand...'}</p>
                <Form inline>
                    <FormGroup>
                        <ControlLabel>Quantity:&nbsp;</ControlLabel>
                        <input className='form-control' type='number' min='0' step='1' value={quantity} onChange={handleQtyChange} />
                    </FormGroup>&nbsp;&nbsp;
                    <FormGroup controlId='formInlineEmail'>
                        <ControlLabel>Intitials:&nbsp;</ControlLabel>
                        <input className='form-control' type='text' min='1' step='1' value={initials} onChange={handleInitialChange} />
                    </FormGroup>&nbsp;&nbsp;
                    {error ?
                        <Alert bsStyle='danger'>{error}</Alert>
                        :
                        <Button title={btnTitle} type='button' bsStyle='primary' disabled={loading || !valid} onClick={handleSave}>
                            Record Physical Inventory {loading && <>(updating)</>}
                        </Button>
                    }
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default PhysicalCompliancePanel;
